import type { WidgetPlayPropertiesType } from '../types';

/**
 * Little helper created to facilitate widget tests
 * -- this could be removed as soon as we are sure that all 'prop.videoId' were removed
 * in favor of 'video.id'
 * @param prop - The component's prop containing the video's infos
 */
export const getVideoId = (prop: WidgetPlayPropertiesType) => prop.video?.id || prop.videoId;
